import script from "./BrandBadge.vue?vue&type=script&setup=true&lang=ts"
export * from "./BrandBadge.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__